import React from "react";
import { CardLoan } from ".";
import Header from "../../Components/Header";
import Text from "../../Components/Text";
import { env } from "src/utils/env";

const CashLoanCards = () => {
  return (
    <React.Fragment>
      <div className="cash-loan-cards__wrapper">
        <div className="cash-loan-cards__container">
          <div className="cash-loan-cards__header">
            <div className="cash-loan-cards__title">
              <Header fontSize={["24px", "40px"]}>
                Apa yang Tepat buat Kamu?
              </Header>
            </div>
            <Text>
              <b>Kredit Multi Guna</b> buat penuhi berbagai kebutuhan keluarga,
              tanpa agunan. Sedangkan <b>Home Credit FlexiCash</b> perlu agunan
              (hanya BPKB) dan menyediakan limit lebih besar.
            </Text>
          </div>
          <div className="cash-loan-cards__body">
            <CardLoan
              title={"Home Credit FlexiCash"}
              description="Limit s.d. Rp100 juta, perlu agunan. Buat kebutuhan besar, termasuk usaha."
              imageSrc={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/6f1622c0-4798-4d4a-a0b2-32f503576680/flexicash-cardloan.png`}
              path={"/pembiayaan-tunai/flexicash"}
            />
            <CardLoan
              title="Kredit Multi Guna"
              description="Limit s.d. Rp100 juta, tanpa agunan. Buat pendidikan, renovasi & lainnya."
              imageSrc={`${env.kenticoAssetURL}/a7507759-f4f5-0038-8fff-c1db251108c1/55120def-0a12-44dd-a745-0cc95f8cdd21/banksampoerna-cardloan.png`}
              path={"/pembiayaan-tunai/kredit-multi-guna"}
            />
          </div>
        </div>
      </div>
      <style jsx>{`
        .cash-loan-cards__wrapper {
          display: flex;
          justify-content: center;
          background-color: #f4f4f4;
        }
        .cash-loan-cards__container {
          max-width: 1032px;
          width: 100%;
          display: flex;
          flex-direction: column;
          padding: 56px 0;
        }
        .cash-loan-cards__body {
          display: flex;
        }
        .cash-loan-cards__title {
          margin-bottom: 8px;
        }
        .cash-loan-cards__header {
          margin: 0 16px;
        }

        @media only screen and (max-width: 720px) {
          .cash-loan-cards__body {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .cash-loan-cards__container {
            padding: 24px 0;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default CashLoanCards;
